import { ChannelType } from './Channel'

export type ChannelSortBy = 'usage' | 'membersCount' | 'type' | 'link'
export type ChannelSortOrder = 'asc' | 'desc'

export type ChannelFilters = {
  search?: string
  categories?: string[]
  types?: ChannelType[]
  sortBy?: ChannelSortBy
  sortOrder?: ChannelSortOrder
}

export const DEFAULT_CHANNEL_FILTERS: ChannelFilters = {
  search: '',
  categories: [],
  types: [],
  sortBy: 'usage',
  sortOrder: 'desc',
}

export const countActiveFilters = (filters: ChannelFilters): number =>
  (filters.categories?.length ?? 0) + (filters.types?.length ?? 0)

export type ChannelSortMode = 'usage' | 'members-desc' | 'members-asc'

export const CHANNEL_SORT_MODES: ChannelSortMode[] = ['usage', 'members-desc', 'members-asc']

export const channelSortMode = (filters: ChannelFilters): ChannelSortMode => {
  if (filters.sortBy !== 'membersCount') return 'usage'
  return filters.sortOrder === 'asc' ? 'members-asc' : 'members-desc'
}

export const withChannelSortMode = (filters: ChannelFilters, mode: ChannelSortMode): ChannelFilters => {
  if (mode === 'usage') return { ...filters, sortBy: 'usage', sortOrder: 'desc' }
  return { ...filters, sortBy: 'membersCount', sortOrder: mode === 'members-asc' ? 'asc' : 'desc' }
}

export const nextChannelSortMode = (mode: ChannelSortMode): ChannelSortMode =>
  CHANNEL_SORT_MODES[(CHANNEL_SORT_MODES.indexOf(mode) + 1) % CHANNEL_SORT_MODES.length]
